import { ArrowCircleDown as r } from "./arrow-circle-down.js";
import { ArrowCircleUp as o } from "./arrow-circle-up.js";
import { ArrowCircleUpFilled as m } from "./arrow-circle-up-filled.js";
import { ArrowCircleDownFilled as i } from "./arrow-circle-down-filled.js";
import { ArrowLeft as t } from "./arrow-left.js";
import { ArrowCircleLeft as p } from "./arrow-circle-left.js";
import { ArrowCircleLeftFilled as f } from "./arrow-circle-left-filled.js";
import { ArrowCircleRight as e } from "./arrow-circle-right.js";
import { ArrowCircleRightFilled as l } from "./arrow-circle-right-filled.js";
import { ArrowLeftRight as n } from "./arrow-left-right.js";
import { ArrowRight as a } from "./arrow-right.js";
import { ArrowRightSmall as h } from "./arrow-right-small.js";
import { ArrowTop as w } from "./arrow-top.js";
import { ArrowBottom as g } from "./arrow-bottom.js";
import { ArrowTopSmall as A } from "./arrow-top-small.js";
import { ArrowBottomSmall as C } from "./arrow-bottom-small.js";
import { ChevronsUp as S } from "./chevrons-up.js";
import { ChevronsDown as R } from "./chevrons-down.js";
import { ChevronUp as L } from "./chevron-up.js";
import { ChevronsLeft as c } from "./chevrons-left.js";
import { ChevronsRight as v } from "./chevrons-right.js";
import { ChevronDown as d } from "./chevron-down.js";
import { ChevronLeft as s } from "./chevron-left.js";
import { ChevronRight as D } from "./chevron-right.js";
import { ChevronUpSmall as U } from "./chevron-up-small.js";
import { ChevronDownSmall as T } from "./chevron-down-small.js";
import { ChevronLeftSmall as x } from "./chevron-left-small.js";
import { ChevronRightSmall as E } from "./chevron-right-small.js";
import { Download as k } from "./download.js";
import { Refresh as u } from "./refresh.js";
import { RefreshSmall as F } from "./refresh-small.js";
import { ExternalLink as q } from "./external-link.js";
import { ExternalLinkSmall as y } from "./external-link-small.js";
import { ArrowDiagonalDownSmall as B } from "./arrow-diagonal-down-small.js";
import { RefreshSmallSquareFilled as N } from "./refresh-small-square-filled.js";
import { Recurring2 as z } from "./recurring-2.js";
import { Expand as I } from "./expand.js";
import { Collapse as K } from "./collapse.js";
import { ExpandVertically as M } from "./expand-vertically.js";
import { ArrowDiagonalDown as V } from "./arrow-diagonal-down.js";
import { LoadingSmall as b } from "./loading-small.js";
import { LoadingLines as j } from "./loading-lines.js";
import { TurnLeft as G } from "./turn-left.js";
import { TurnRight as H } from "./turn-right.js";
import { SkipUp as J } from "./skip-up.js";
import { SkipDown as O } from "./skip-down.js";
import { SkipLeft as P } from "./skip-left.js";
import { SkipRight as Q } from "./skip-right.js";
import { Size as W } from "./size.js";
import { UpDown as X } from "./up-down.js";
import { AccountSwitch as Y } from "./account-switch.js";
import { Move as Z } from "./move.js";
import { EnterKey as _ } from "./enter-key.js";
import { Inheritance as $ } from "./inheritance.js";
import { Share1 as rr } from "./share-1.js";
import { Exit as or } from "./exit.js";
import { Upload as mr } from "./upload.js";
import { NavigationExpand as ir } from "./navigation-expand.js";
import { NavigationCollapse as tr } from "./navigation-collapse.js";
import { TriangleUp as pr } from "./triangle-up.js";
import { TriangleDown as fr } from "./triangle-down.js";
import { TriangleLeft as er } from "./triangle-left.js";
import { TriangleRight as lr } from "./triangle-right.js";
import { RefreshSmallSquare as nr } from "./refresh-small-square.js";
import { AngledRight as ar } from "./angled-right.js";
import { AngledLeft as hr } from "./angled-left.js";
const To = {
  ArrowCircleDown: r,
  ArrowCircleUp: o,
  ArrowCircleUpFilled: m,
  ArrowCircleDownFilled: i,
  ArrowLeft: t,
  ArrowCircleLeft: p,
  ArrowCircleLeftFilled: f,
  ArrowCircleRight: e,
  ArrowCircleRightFilled: l,
  ArrowLeftRight: n,
  ArrowRight: a,
  ArrowTop: w,
  ArrowBottom: g,
  ArrowTopSmall: A,
  ArrowBottomSmall: C,
  ChevronsUp: S,
  ChevronsDown: R,
  ChevronUp: L,
  ChevronsLeft: c,
  ChevronsRight: v,
  ChevronDown: d,
  ChevronLeft: s,
  ChevronRight: D,
  ChevronUpSmall: U,
  ChevronDownSmall: T,
  ChevronLeftSmall: x,
  ChevronRightSmall: E,
  Download: k,
  Refresh: u,
  RefreshSmall: F,
  ExternalLink: q,
  ExternalLinkSmall: y,
  ArrowDiagonalDownSmall: B,
  RefreshSmallSquareFilled: N,
  Recurring2: z,
  Expand: I,
  Collapse: K,
  ExpandVertically: M,
  ArrowDiagonalDown: V,
  LoadingSmall: b,
  LoadingLines: j,
  TurnLeft: G,
  TurnRight: H,
  SkipUp: J,
  SkipDown: O,
  SkipLeft: P,
  SkipRight: Q,
  Size: W,
  UpDown: X,
  AccountSwitch: Y,
  Move: Z,
  EnterKey: _,
  Inheritance: $,
  Share1: rr,
  Exit: or,
  Upload: mr,
  NavigationExpand: ir,
  NavigationCollapse: tr,
  TriangleUp: pr,
  TriangleDown: fr,
  TriangleLeft: er,
  TriangleRight: lr,
  RefreshSmallSquare: nr,
  AngledRight: ar,
  AngledLeft: hr,
  ArrowRightSmall: h
};
export {
  To as Arrows
};
